"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenElements = void 0;
const react_1 = __importDefault(require("react"));
const flattenElements = (elements, config, target) => {
    react_1.default.Children.forEach(elements, child => {
        if (config[child.type]) {
            target.push(child);
        }
        else {
            exports.flattenElements(child.props.children, config, target);
        }
    });
};
exports.flattenElements = flattenElements;
//# sourceMappingURL=flatten.js.map